module.exports = __webpack_public_path__ + "img/cooperation21.a5af4e74.png";